import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { getObjectValueByPath } from '@/helpers/common/helper'

export function useLocale() {
  const i18n = useI18n({ useScope: 'global' })

  const locale = computed(() => i18n.locale.value)

  function getLocaleMessage(path: string): unknown {
    const messages = i18n.getLocaleMessage(locale.value)
    return getObjectValueByPath(messages, path)
  }

  return { locale, getLocaleMessage }
}
